import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserSessionActionCreators } from 'app/reducers/UserSessionRedux'
import { confirmVerificationCodeSuccessSelector } from 'app/selectors/user'
import { Button, Input } from 'controls'
import useUserSessionLogger, {
  USER_SESSION_ACTION_TYPES,
} from 'components/UserSession/useUserSessionLogger'
import CodeVerification from './CodeVerification'
import {
  DeviceFooter,
  DeviceHeader,
  DontShareCode,
  SendVerificationCode,
} from './Commons'
import { CODE_VERIFICATION_TYPES } from './constants'
import { registerNewDeviceFormStyles } from './styles'

const MAPPED_ERRORS = {
  'user session with this alias already exists.':
    'Este alias ya existe, por favor ingrese uno diferente.',
}

function getFieldError(name, error, errors) {
  if (error) {
    const fieldErrors = errors[name] || []
    const fieldError = fieldErrors[0]
    return {
      touched: true,
      invalid: fieldErrors.length > 0,
      error: MAPPED_ERRORS[fieldError] || fieldError,
    }
  }
}

function RegisterNewDeviceForm() {
  useUserSessionLogger(USER_SESSION_ACTION_TYPES.CREATE_SESSION)

  const dispatch = useDispatch()
  const [{ alias, validateAlias }, setValues] = useState({
    alias: '',
    validateAlias: false,
  })
  const { loading, success, error, errors } = useSelector(
    state => state.userSession.createSessionFeedback,
  )
  const confirmSuccess = useSelector(confirmVerificationCodeSuccessSelector)

  useEffect(() => {
    dispatch(UserSessionActionCreators.cleanFeedback())
  }, [])

  function createDevice() {
    dispatch(UserSessionActionCreators.createSessionRequest(alias))
  }

  function onChange({ target }) {
    if (error) {
      dispatch(UserSessionActionCreators.cleanFeedback())
    }
    setValues(values => ({
      ...values,
      validateAlias: true,
      [target.name]: target.value,
    }))
  }

  const aliasError = validateAlias && alias.length < 6
  const aliasErrors = aliasError
    ? { alias: [alias.length < 6 && 'Mínimo 6 carácteres'] }
    : errors

  const disableCreateDevece = !confirmSuccess || !alias || alias.length < 6

  return (
    <div
      data-qa="register-new-device-form"
      className="register-new-device-form"
    >
      <DeviceHeader title="Registra tu sesión" />

      <div className="register-new-device-input-container">
        <Input
          name="alias"
          value={alias}
          label="Alias (mínimo 6 carácteres)"
          placeholder="Alias de la sesión"
          onChange={onChange}
          className="form-input-margin"
          meta={getFieldError('alias', aliasError || error, aliasErrors)}
        />
      </div>

      <div className="register-code-verification form-input-margin">
        <CodeVerification />
      </div>

      {confirmSuccess && (
        <div className="register-button-container form-input-margin">
          <Button
            disabled={disableCreateDevece}
            loading={loading}
            onClick={createDevice}
            size="large"
            color={disableCreateDevece ? 'tertiary' : 'primary'}
            className="register-button"
          >
            Continuar
          </Button>
        </div>
      )}

      <DontShareCode />

      <DeviceFooter>
        <SendVerificationCode
          codeVerificationType={CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE}
        />
      </DeviceFooter>

      <style jsx>{registerNewDeviceFormStyles}</style>
    </div>
  )
}

export default RegisterNewDeviceForm
